<template>
  <!-- visit-finish -->
  <div class="vf">
    <div class="vf-panel">
      <img src="@/assets/img/icon-success.png" alt="提交成功">
      <div class="vf-info">购票成功</div>
      <div class="vf-txt" >
          您已完成购票流程，可前往
          <br>
          个人中心-我的证件查看票务信息
      </div>
      <div class="vf-award-btn" @click="link('card')">前往证件</div>
      <div class="vf-award-btn" @click="link('act')">返回活动列表</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import gql from 'graphql-tag';

export default {
  // 注册成功页面
  data() {
    return {
      CardId: "",
      VisitorRegRemind:null, // 自定义注册完成描述
      actData:'',
    };
  },
  computed: {
    ...mapGetters({
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId',
      exhibitionInfo:'getExhibitionInfo',
      exhibitionConfig:"getExhibitionConfig"
    }),
    actId(){ return  this.$route.params.id },
    ActDetailsGql(){ // 查询活动详情
        return gql`query activity($id: Guid!){
                activity(id: $id){
                    exhibitionId
                    exhibitorId
                    id
                    externalLink
                    hasLive
                    liveAuditState
                    acvitityType
                }
            }`
        },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
      LinkToMyPapers:"linkTo/LinkToMyPapers",
      LinkFooter:'linkTo/LinkFooter'
    }),
    async init(){
        this.getActDetails();
        await this.$Myapollo.getUserInfo(this);
    },
    async getActDetails(){
        this.$apollo.addSmartQuery('activity', {
            query:this.ActDetailsGql, 
            variables: {
                id:this.actId
            },
            fetchPolicy: "no-cache", //清理缓存
            result(res) {
                if(res.data.activity){
                    this.actData = res.data.activity;
                    this.$store.commit("setExhibitionId",this.actData.exhibitionId);
                } 
            },// 错误处理
            error(error) {
                console.error(error,'error错误处理')
            }
        })
    },
    link(type){
      switch(type){
        case 'act' :
          var opt = {
            url: `/activity/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          // this.LinkAct(this.actData);
          break;
        case 'card' :
          this.LinkToMyPapers();
          break;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.vf {
  &-panel {
    text-align: center;
    background: #fff;
    padding: 36px 0 30px;
    // margin-bottom: 12px;
    // border-bottom: 10px solid #f5f5f5;
    img {
      width: 75px;
      display: inline-block;
      margin-bottom: 15px;
    }
  }
  &-info {
    font-size: 20px;
    line-height: 24px;
    color: #0290fe;
    margin-bottom: 17px;
  }
  &-txt {
    font-size: 14px;
    line-height: 24px;
    color: #999;
    margin-bottom: 25px;
    width: 76%;
    margin: 0 auto;
  }
  &-btn {
    width: 180px;
    line-height: 35px;
    background-color: #0290fe;
    border-radius: 3px;
    color: #fff;
    margin: 0 auto 12px;
    font-size: 15px;
  }
  &-award {
    padding: 10px 15px;
    background: #fff;
    display: flex;
    align-items: center;
    img {
      width: 75px;
      height: 50px;
    }
    &-txt {
      padding: 0 11px;
      font-size: 15px;
      color: #333;
      flex: 1;
    }
    &-btn {
      width: 3.5rem;
      height: .92rem;
      text-align: center;
      line-height: .92rem;
      border-radius: 3px;
      border: solid 1px #1890ff;
      color: #1890ff;
      font-size: .36rem;
      margin: .6rem auto 0;
    }
  }
}
</style>